<template>
  <section class="grid-section  l-section wpb_row height_small width_full mpc-row">
    <div class="l-section-h i-cf">
      <div class="g-cols type_default valign_top">
        <div class="vc_col-sm-12 wpb_column vc_column_container mpc-column">
          <div class="vc_column-inner  vc_custom_1489709117144">
            <div class="wpb_wrapper">
              <h4 class="grid-section__title">{{ $t("Сім’я ресторанів «Classic»") }}</h4>
              <div class="grid-section__list">
                <template
                  v-for="restaurant in [...preparedRestaurantList.slice(0, 4), 'logo', ...preparedRestaurantList.slice(4)]">
                  <div
                    v-if="restaurant === 'logo'"
                    :key="restaurant"
                    class="grid-section__item"
                  >
                    <div class="grid-section__logo-wrap">
                      <img src="../assets/images/logos.jpg" alt="classic"/>
                    </div>
                  </div>
                  <GridItem
                    v-else
                    :key="restaurant.id"
                    :restaurant="restaurant"
                    class="grid-section__item"
                  />
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import GridItem from './GridItem'
import {mapState} from 'vuex'

export default {
  name: 'GridSection',
  components: {GridItem},
  data() {
    return {
      pending: false
    }
  },
  computed: {
    ...mapState('restaurants', ['all_restaurants']),
    preparedRestaurantList() {
      return [...this.all_restaurants].sort((a, b) => a.sort_order - b.sort_order)
    }
  },
  created() {
    this.$store.dispatch('restaurants/load')
  }
}
</script>

<style>

</style>
